 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"a67210f8a1e3787549ce","1":"cd80700e3fb895ed3793","2":"ea1928c6312a0d2b7729","3":"8676684736de81f7e92b","4":"68e8e5391c2d51fb63b1","5":"74ab25768617163d5440","6":"e413aabb35a1719476f3","AccountOpening":"d53358ed32bddac145e5","BackTopBottom":"eca7ba3b6588b5d0ba25","Caption":"0cfd4c656ab1a05a68e0","Copyright":"656059e0ec7f09d88536","DataBox":"9fbf006db5369863b6e8","HomeFooter":"fb4c2e1053531b717be6","Img":"ceb3ef7599d71828a7db","LivePlayer":"5e58a111318a43ee5adb","MoreTabs":"4092f48e58e105cc1c3c","Nav":"18e788052763603cd43f","NormalCaption":"8c8ecad06c0fd5a3fb97","Offline":"b5e57dca02e1ed6b46fc","QQShare":"0c6bb38006719c504725","Tip":"4014a098d09e58f26dbd","ViewMoreLink":"9e23921afac5f0e7aa11","WxLaunchApp":"019393e86c124ddbdc07","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"87b23af614a8e97141bc","Atlas":"f28643ee89b63d47c555","FiveNavPic":"e598de0575220bb53d68","FourNavPic":"104ec577461d2d334790","ThreeNavPic":"67af7fff8ff55369533d","vendors~BigImage~NewsStream~NoImage~OneImage~Stick~ThreeImage~TwoImage":"3abc2015cb2fd19f1caa","Stick":"552ce4776eb8803ca7c0","TwoImage":"744922be7aca883037de","vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage":"3d934ab53f81e2024ee4","BigImage":"a1626768f7cebc07b1ac","NoImage":"18f95d2f1c6ecda72168","OneImage":"8ad0764c7b7d6b3e616c","ThreeImage":"bc386ec149467d490d7f","vendors~NewsStream":"e182cd1bdc483bfcc9b8","vendors~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~IndexSlides~InformationFlow~MarkTa~bbbc43f7":"468b4ae864527d600482","BrowserGuideLayer":"89b5f4c3f1a1f0eeaec0","MarkTabs":"ab78e779e9436176a9c5","PageBottomBrand":"e267c7b9e4661bdfbe86","WXGuideLayer":"4467727a3bb79161d08a","MdBanner":"115cdcf0c2fbb7990159","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"182f06cf34a32cb3efa1","BigImg":"137ce9c6bca1c8302b5f","SingleTitle":"15ac59cc4dc88b1a6ae8","SlideImg":"a42d821757ec2fbf14c4","TwoImg":"a709301d87e55e90530d","vendors~BigTopic~InformationFlow~TitleImg":"b1fff3d55096bd1b8e65","InformationFlow":"110e33ea88f621562b95","BigTopic":"bef012f5a9d93ca15c87","TitleImg":"ce237c531240533ab82f","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"c01e2629ecc58e398009","vendors~BottomSlides~UpgradeBottomSlides":"b98101ae25354eaec38e","UpgradeBottomSlides":"749f213fc9bc27ef0e90","vendors~IndexSlides":"29c27ec29917a35312ec","vendors~CallupHead":"a426e7974b756b28ed9a","vendors~Comment~ShareComment":"9240cc3ef0075985597b","vendors~ShareComment":"b39d6d1232d1b92da993","vendors~Player":"d823c4dc9684db465dec","vendors~Survey":"6f6beb80ad5abac18930","vendors~WxLaunchHack":"7f4fc753f51e5f87d87d","Slides":"b34ad0b8ef1ba7095829","vendors~NormalSlides":"fc3cc6351ad576e1a46c","vendors~ShareSlides":"49344df2bbf099f56f9d","vendors~CallupVideoAppHead":"3fbf868033fa59987fbb","vendors~Comment~LoginDialog":"0db9e3377ccbd03beea7","LoginDialog":"095e552a02d893e29fc5","vendors~Comment":"b52da30b735a351be39c","Comment":"39c0ffc8a23f9c828fe8","vendors~Hongbao":"6878e9ec74a0ab622ebe","vendors~NormalTabs":"fdef6a415f6ed923eed7","vendors~SimpleGuideLayer":"39ec7b2e2ff3895bae48","vendors~SlidesTabs":"8c013e9889f40fa387b7","vendors~pics":"3455870fcfa316a0130b","pics":"7335f6266b03a8c040a3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/content/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
